import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { errorHandl, setFormData, setFormDataV2 } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url-utils';

@Injectable({
  providedIn: 'root'
})
export class EquipmentService {

  constructor(private http: HttpClient)  { }


  getEquipmentbyId(id) {
    return this.http.get<any>(urls.BASE_URL  + urls.EQUIPMENT_URL + `/${id}`)
      .pipe(
        catchError(errorHandl)
      );
  }


  saveEquipment(id, payload) {
    if (id) {
      // Edit
      return this.http.put<any>(urls.BASE_URL+ urls.EQUIPMENT_URL + `/${id}`, payload)
        .pipe(
          catchError(errorHandl)
        );
    } else {
      // Add
      return this.http.post<any>(urls.BASE_URL + urls.EQUIPMENT_URL , payload)
        .pipe(
          catchError(errorHandl)
        );
    }
  }

  getEquipments(queryParams?) {
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get<any>(urls.BASE_URL + urls.EQUIPMENT_URL, {params})
      .pipe(
        catchError(errorHandl)
      );
  }
}
